import angular from 'angular';
import './index';
import incrementalDataStoreModule from './IncrementalDataStore';

class IncrementalDataStoreService {
  constructor(
    $q,
    LogService,
    buildIncrementalDataStoreForType
  ) {
    this.$q = $q;
    this.LogService = LogService;
    this.buildIncrementalDataStoreForType = buildIncrementalDataStoreForType;
    this.incrementalDataStoresByType = {};
    this.buildPromisesByType = {};
  }

  getOrBuild(type, ...buildArgs) {
    return this.get(type)
      .then(store => {
        if (store) {
          return store;
        } else {
          return this.build(type, ...buildArgs);
        }
      });
  }

  get(type) {
    return this.$q.when(this.incrementalDataStoresByType[type]);
  }

  build(type, ...buildArgs) {
    if (!(type in this.buildPromisesByType)) {
      this.buildPromisesByType[type] = this.$q
        .when(this.buildIncrementalDataStoreForType(type, ...buildArgs))
        .then(store => {
          if (type in this.incrementalDataStoresByType) {
            this.LogService.warn(`IncrementalDataStoreService.build(${type}) overwriting existing data store`);
          }
          this.incrementalDataStoresByType[type] = store;
          return store;
        });
    }
    return this.buildPromisesByType[type];
  }

  destroy(type) {
    return this.get(type)
      .then(store => {
        if (store) {
          store.destroy();
          delete this.incrementalDataStoresByType[type];
          delete this.buildPromisesByType[type];
          return true;
        } else {
          return false;
        }
      });
  }
}

const moduleName = 'recaps.services.IncrementalDataStoreService';
const module = angular.module(moduleName, [
  'recaps.services',
  incrementalDataStoreModule.name,
]);

module.service('IncrementalDataStoreService', IncrementalDataStoreService);

export default module;
